const breakpointKeys = {
  large: "LARGE",
  medium: "MEDIUM",
  xsmall: "XSMALL",
};

const breakpointNummeric = {
  large: 9999,
  medium: 983,
  xsmall: 695,
};

const config = {
  events: {
    RESIZE: "bfv-event-resize",
    VIEWPORT_CHANGED: "bfv-event-viewport-changed",
    VIEWPORT_SCROLL: "bfv-event-scroll",
    LIGHTBOX_SCROLL: "bfv-event-lightbox-scroll",
    VIEWPORT_SCROLL_SMOOTH: "bfv-event-scroll-smooth",
    ESCAPE_KEYDOWN: "bfv-escape-keydown",
    MODULES_INITIALIZATION_COMPLETE: "bfv-modules-initialization-complete",
    MODAL_INITIALIZATION_COMPLETE: "bfv-modal-initialization-complete",
    BFV_IMAGE_LOAD: "bfv-image-load",
    BFV_OPEN_MOBILE_MENU: "bfv-open-mobile-menu",
    BFV_MULTISELECT_CLICKED: "bfv-multiselect-clicked",
    BFV_DATEPICKER_CHANGED: "bfv-datepicker-changed",
    BFV_TEXTINPUT_CHANGED: "bfv-textinput-changed",
    BFV_RESET_FILTER: "bfv-reset-filter",
    BFV_UPLOADED_IMG: "bfv-uploaded-img",
    BFV_DELETED_IMG: "bfv-deleted-img",
    BFV_UPLOADED_VIDEO: "bfv-uploaded-video",
    BFV_ZIP_SEARCH_CHANGE: "bfv-zip-serach-change",
  },
  eventstData: {
    BFV_RESET_FILTER__ALL: {
      value: "reset-all",
    },
  },
  datepicker: {
    changeListenerClass: "js-datepicker-on-change",
    clearListenerClass: "js-datepicker-on-clear",
  },
  multiselect: {
    changeListenerClass: "js-multiselect-on-change",
  },
  input: {
    changeListenerClass: "js-input-on-change",
  },
  focus: {
    disabledClass: "disable-focus-styles",
  },
  viewports: [
    {
      name: breakpointKeys.xsmall,
      width: breakpointNummeric.xsmall,
    },
    {
      name: breakpointKeys.medium,
      width: breakpointNummeric.medium,
    },
    {
      name: breakpointKeys.large,
      width: breakpointNummeric.large,
    },
  ],
};

const keyCodes = {
  ESCAPE: 27,
  LEFT: 37,
  RIGHT: 39,
  ENTER: 13,
  SPACE: 32,
  UP: 38,
  DOWN: 40,
  TAB: 9,
  DEL: 8,
  DEL2: 46,
};

const ignoredKeyCodes = [
  keyCodes.ENTER,
  16,
  17,
  18,
  19,
  20,
  keyCodes.ESCAPE,
  35,
  36,
  keyCodes.LEFT,
  keyCodes.UP,
  keyCodes.RIGHT,
  keyCodes.DOWN,
  91,
  93,
  224,
];

const keyCodesCombined = Object.assign(keyCodes, {
  ignoredKeyCodes,
});

const animationSettings = {
  default: {
    DOUBLE_DURATION: 0.6,
    DURATION: 0.3,
    HALF_DURATION: 0.15,
    CURVE: "power1.out",
  },
  easeIn: {
    CURVE: "power1.in",
  },
  shorterEaseIn: {
    DURATION: 0.2,
    CURVE: "power1.in",
  },
  bounce: {
    DURATION: 0.15,
    OUT_DURATION: 0.3,
    DELAY: 0.15,
    CURVE: "bounce.out",
    CURVE_IN: "bounce.in",
  },
};

const BODY_TAB_FOCUS_CLASS = "keyboard-focus";

export {
  config as CONFIG,
  animationSettings as ANIMATIONS,
  breakpointKeys as BREAKPOINTS,
  breakpointNummeric as BREAKPOINTS_NUMERIC,
  keyCodesCombined as KEYCODES,
  BODY_TAB_FOCUS_CLASS,
};

